import * as ol from 'openlayers'
import BaseAspect from './BaseAspect.js'
import { translate } from '@/translation/native_translate.js';

export default class BasePointAspect extends BaseAspect {

  constructor(data) {
    super(data);

    this.setProperties(data);
    // this.set('geometry', new ol.geom.GeometryCollection([new ol.geom.Point(ol.proj.transform(data.position, 'EPSG:4326', 'EPSG:3857'))]));
    // if (data.hasOwnProperty('type')) {
    //   this.set('type', data.type);
    // } else {
    //   this.set('type', 'BasePointAspect');
    // }
      this.style = [
        new ol.style.Style({
          image: new ol.style.Icon(({
            anchor: [0.5, 1],
            src: "data:image/png;base64,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",
            color: "#000000",
          }))
        })
      ];
    this.warningMessage = 'WARNING_MESSAGE';
    this.warningTitle = 'WARNING_MESSAGE_TITLE';

    this.setZIndex(5);
  }


  setProperties(data) {
    super.setProperties(data);
    this.set('geometry', new ol.geom.GeometryCollection([new ol.geom.Point(ol.proj.transform(data.position, 'EPSG:4326', 'EPSG:3857'))]));
    if (data.hasOwnProperty('type')) {
      this.set('type', data.type);
    } else {
      this.set('type', 'BasePointAspect');
    }
  }

  createStyle() {
    return this.style;
  }

  getGpsPosition() {
    let convertedPosition = ol.proj.transform(this.get('geometry').getCoordinates(), 'EPSG:3857', 'EPSG:4326');
    return convertedPosition;
  }

  rightClick(pixel, gps, rightClickBehaviour = 0) {
    let forwardBehave = true;
    switch (rightClickBehaviour) {
      case 0: //normal behaviour

        break;
      case 1: //Relation creation
        forwardBehave = false;

        break;
    }

    if (forwardBehave) {
      // let suffix = ' ' + this.get('referenceName');
      // let customData = this.getObject();
      // customData.form = this.objectDefinition();
      // let boxConfig = {
      //   suffix: suffix,
      //   customData: customData,
      //   gpsData: gps,
      //   parentId: 'ContextMenu',
      //   id: 'ContextMenu', //specific id for context menu box
      //   component: 'ContextMenu',
      //   name: "Menu",
      //   left: (pixel[0] + 10),
      //   top: (pixel[1] + 10 + 49), // +49 to adjust for navigation bar
      //   actions: [{
      //       id: this.get('rightClickSetting'),
      //       title: translate('CM_SETTINGS') + suffix,
      //       name: translate('CM_SETTINGS')
      //     },
      //     {
      //       id: '_removeAction',
      //       title: translate('CM_REMOVE'),
      //       name: translate('CM_REMOVE'),
      //       '_function': () => { this.removeObject(); }
      //     }
      //   ],
      // }

      // this.$emit('closeBoxMgr', 'ContextMenu');
      // setTimeout(function() { this.$emit('openBoxMgr', boxConfig); }, 200);
    }
  }

  removeObject() {
    window.Event.vue.$confirm(translate(this.warningMessage), translate(this.warningTitle), {
      confirmButtonText: translate('YES'),
      cancelButtonText: translate('NO'),
      type: 'warning'
    }).then(() => {
      var requestObject = {
        "childId": {
          "datatype": "string",
          "value": this.getId(),
        },
        "cleanDatabase": {
          "datatype": "bool",
          "value": true,
        }
      };

      if (this.get('parentId') === 'undefined') {
        this.$notify.error({
          title: "DESTINATION_OBJECT_FAILS_TO_REMOVE",
          message: "ERROR",
          duration: 0
        });
      } else {
        this.setLastAction('removeObject');
        const request = dssUtility.createDSSRequest(this.get('parentId'), "cleanupChild", requestObject);
        window.socket.sendMessage(request, () => {
          window.Event.vue.$notify.success({
            title: "DESTINATION_OBJECT_REMOVED",
            message: "Success"
          });
        });
      }
    });
  }
}
